function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#FDF1DF",
  d: "M21.5 11c0 5.799-4.701 10.5-10.5 10.5C5.2 21.5.5 16.799.5 11S5.2.5 11 .5C16.799.5 21.5 5.201 21.5 11z"
}), React.createElement("path", {
  fill: "#F5BB5F",
  d: "M11 1C5.477 1 1 5.477 1 11s4.477 10 10 10 10-4.477 10-10S16.523 1 11 1zM0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11z"
}), React.createElement("g", {
  transform: "translate(12.897 6.828)"
}, React.createElement("path", {
  fill: "#F5BB5F",
  d: "M2.974 2.08c0 1.128-.605 2.042-1.353 2.042S.268 3.208.268 2.08C.268.952.873.038 1.621.038S2.974.952 2.974 2.08z"
})), React.createElement("g", {
  transform: "translate(6.069 6.828)"
}, React.createElement("path", {
  fill: "#F5BB5F",
  d: "M2.86 2.08c0 1.128-.606 2.042-1.354 2.042-.747 0-1.353-.914-1.353-2.042C.153.952.759.038 1.506.038c.748 0 1.354.914 1.354 2.042z"
})), React.createElement("g", {
  transform: "translate(5.31 13.655)"
}, React.createElement("path", {
  fill: "#F5BB5F",
  d: "M.172.81a.5.5 0 0 1 .5-.5h10.035a.5.5 0 1 1 0 1H.672a.5.5 0 0 1-.5-.5z"
})));

var SvgNeutral = function SvgNeutral(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNeutral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Neutral.697edfd6.svg";
export { ForwardRef as ReactComponent };